import React, { useState, useEffect } from "react";

import { CustomRadio } from "../CustomRadio/CustomRadio"
import styles from "./BrnadPlan.module.css"
import FleekCoin from "../../asset/icons/fleek-coin-logo.png"
import CheckLogo from "../../asset/icons/checkLogo.png"
import ExclamationIcon from "../../asset/icons/exclamationIcon.png"
import { trackAddToCart } from '../../utils/analyticsService';

import disableCheck from "../../asset/icons/disableCheck.png"
import disableExclamation from "../../asset/icons/disableExclamation.png"
import cx from 'classnames';
import Helper from "../../utils/Helper";
import ConfettiHelper from '../../utils/ConfettiHelper';

const isMobile = Helper.isMobile()



const BenefitFun = (benefits,show,subtext,disable)=>{

    return(
        <div className={ show ?cx(styles.BenefitsContainer,styles.show): styles.BenefitsContainer  }>
                    <div className={styles.VerticleSpacer}></div>
                    <div className={styles.Benefits}>
                        {benefits.map((ele,idx)=>(
                            <div className={styles.BenefitContain} key={idx}>
                                <img className={styles.CheckLogo} src={disable?disableCheck:CheckLogo} alt="check Logo"/>
                                <p className={ disable ?cx(styles.Benefit,styles.disable):styles.Benefit}>{ele}</p>
                            </div>    
                        ))}
                    </div>
                    <div className={styles.VerticleSpacer}></div>
                    {subtext && <div  className={styles.message}>
                        <img className={styles.ExclamationIcon} src={disable? disableExclamation: ExclamationIcon} alt="Exclamation Icon" />
                        <p className={disable ? cx(styles.MessageText,styles.disable): styles.MessageText}>{ subtext || ''}</p>
                    </div>}
        </div>
    )
}

export const DigitalBrandPlan = ({AddToCart, plan,index,setSelectedPlan,selectedPlanIdx})=>{
    // State to track if button is in loading state
    const [isLoading, setIsLoading] = useState(false);
    
    // Store currency type in localStorage and handle auto-login for USD
    React.useEffect(() => {
        const handleCurrencyChange = async () => {
            if (plan?.currency_type) {
                await Helper.checkAndHandleUSDCurrency(plan.currency_type);
            }
        };

        handleCurrencyChange();
    }, [plan?.currency_type]);

    const inputHandle = ()=>{
        setSelectedPlan(index)
    }
    const check = index===selectedPlanIdx
    let disable = plan.is_out_of_stock || plan.already_availed;
    
    const disableText = ()=>{
        if(plan.is_out_of_stock){
            return "Not Available"
        }
        else{
            return "Already availed"
        }
    }

    // Hide USD plans that are out of stock
    if (plan.currency_type === 'usd' && plan.is_out_of_stock) {
        return null;
    }

    const CardConditionalStyle = ()=>{

        if(disable){
            return cx(styles.BrandCard,styles.disable)
        }
        else{
            return check ? cx(styles.BrandCard,styles.check):styles.BrandCard;
        }
    }
    const handleMobClick = ()=>{
        if(window.innerWidth<1280 && !disable){
            inputHandle()
        }
    }
    const benefits = plan.description.split("\n") || []

    const getCurrencySymbol = (currency_type) => {
        return currency_type === 'usd' ? '$' : '₹';
    }

    const currencySymbol = getCurrencySymbol(plan.currency_type);

    // Handle the buy now button click
    const handleBuyNow = async (e) => {
        try {
            e.stopPropagation(); // Prevent event bubbling
            console.log("handleBuyNow called");
            
            // Prevent multiple clicks
            if (isLoading) return;
            setIsLoading(true);
            
            // Show small confetti blast on click
            ConfettiHelper.smallBlast();
            
            // Create payload for API
            const payload = {
                subscription_plan: Number(plan.subscription_plan_id),
                quantity: plan.quantity
            };
            
            // Track the AddToCart event with Facebook CAPI before calling the API
            try {
                // Create product data for CAPI
                const productData = {
                    subscription_plan_id: plan.subscription_plan_id,
                    plan_name: plan.plan_name,
                    discounted_cost: plan.discounted_cost,
                    currency_type: plan.currency_type,
                    service_name: plan.service_name || '',
                    quantity: plan.quantity || 1,
                    plan_id: plan.id
                };
                
                // Get user data if possible
                let userData = {};
                
                // Call the API to add the item to cart
                await AddToCart(payload);
                
                // Use centralized analytics for add to cart (handles all platforms)
                trackAddToCart(productData, userData);
                console.log("Centralized AddToCart event tracked successfully");
                
            } catch (error) {
                console.error("Error tracking Facebook CAPI AddToCart event:", error);
                // Still proceed with AddToCart even if CAPI tracking fails
                await AddToCart(payload);
            }
        } catch (error) {
            console.error("Error in handleBuyNow:", error);
            setIsLoading(false);
        }
    };

    return(
        <div onClick={handleMobClick} className={CardConditionalStyle()}>
            <div className={styles.PlanMainInfo}>
                <div className={styles.planTitle}>
                    <div className={styles.radioBtn}>
                        {disable?<div className={styles.mockCircle}></div> :<CustomRadio checked={index===selectedPlanIdx} />}
                    </div>
                    <div className={styles.Plan}>
                        <p className={ check ? cx(styles.Name, styles.selected) : styles.Name }>{plan.plan_name}</p>
                        <p className={disable ? cx(styles.Validity,styles.disable): styles.Validity}>{plan.duration} {plan.duration_type}</p>
                    </div>
                </div>
                {
                    disable ? 
                    <div className={styles.mobNewPriceDisplay}>
                        <p className={cx(styles.HeadPrice,styles.disable)} >{currencySymbol} {Math.floor(plan.mrp_price)}</p>
                    </div>
                    :
                    <div className={styles.mobNewPriceDisplay}>
                    <div className={styles.newPrice}>
                        <p className={styles.markedPrice}>{currencySymbol}{plan.mrp_price}</p>
                        <p className={styles.sellingPrice}>{currencySymbol}{Math.floor(plan.discounted_cost)}</p>
                    </div>
                    {Math.floor(plan.max_coin_usable) ? <div className={styles.fleekCoinDetail}>
                        with <img className={styles.FleekCoinPrice} src={FleekCoin} alt="fleek coin logo"/> 
                        ₹{Math.floor(plan.max_coin_usable)}
                    </div> : ''}
                </div>}
                {/* <p className={disable ? cx(styles.HeadPrice,styles.disable): styles.HeadPrice} >₹ {Math.floor(plan.cost)}</p> */}
            </div>
            {
                disable && 
                <div className={styles.MobDisableText}>
                <p className={styles.disableText}>{disableText()}</p>
                        {/* <>
                            <p className={styles.PriceText}>Fleek Price:</p>
                            <p className={styles.PayPrice}>₹{Math.floor(plan.discounted_cost)} + </p>
                            {plan.max_coin_usable && <div className={styles.FleekPriceSec}>
                                <img className={styles.FleekCoin} src={FleekCoin} alt="fleek coin logo"/>
                                <p className={styles.FleekPrice}> ₹{plan.max_coin_usable}</p>
                            </div>}
                            <div className={styles.Seperator}></div>
                            <p className={styles.Discount}>{plan.new_discount_percentage}% OFF</p>
                        </> */}
                </div>
            }    
            <div className={styles.mobBenefit}>
                {
                    BenefitFun(benefits,check,plan.activation_type_message,disable)
                }
            </div>
            <div className={styles.deskBenefit}>
                {BenefitFun(benefits,true,plan.activation_type_message,disable)}
            </div>
            <div className={styles.DeskActions}>
                <div className={styles.PriceDetailDesk}>
                {
                    disable ?
                        <>
                            <p className={cx(styles.HeadPrice,styles.disable)} >{currencySymbol} {Math.floor(plan.mrp_price)}</p>
                            <p className={styles.disableText}>{disableText()}</p>
                        </>
                        :
                        <>
                            <div className={styles.newPrice}>
                                {plan.new_discount_percentage ? <p className={styles.markedPrice}>{currencySymbol}{plan.mrp_price}</p> : ''}
                                <p className={styles.sellingPrice}>{currencySymbol}{Math.floor(plan.discounted_cost)}</p>
                            </div>
                            {Math.floor(plan.max_coin_usable) ? <div className={styles.fleekCoinDetail}>
                                with <img className={styles.FleekCoin} src={FleekCoin} alt="fleek coin logo"/> 
                                ₹{Math.floor(plan.max_coin_usable)}
                            </div> : ''}
                        </>
                }    
                </div>
                {!disable && 
                  <div 
                    onClick={handleBuyNow} 
                    className={`${styles.BuyNowButton} ${isLoading ? styles.loading : ''}`}
                  >
                    {isLoading ? (
                      <span className={styles.spinner}></span>
                    ) : (
                      "BUY NOW"
                    )}
                  </div>
                }
            </div>
        </div>
    )
}
